/**
 * Collagen Bundle Upsell Handler
 * Manages bundle upsells for the main collagen mask product in cart drawer
 */


class CollagenBundleUpsell {
  constructor() {
    this.mainProductId = 7939752624310;
    this.mainVariantId = 43805225222326;
    this.sellingPlan = 4600922294;
    
    // Kaching Bundle IDs (extracted from the original bundle definition)
    this.bundleConfig = {
      dealId: "BdHg",
      bundleId: "c3fcf7da-2886-4ab8-8892-05a0d8b39133",
      bars: {
        "2-get-1": "eb0debe1-9410-4803-8733-8d231eaaf915",
        "3-get-3": "765853a2-09f3-4b2e-9a9f-68247b72f44b"
      },
      gifts: {
        skincare: { id: "HtEg", variantId: 43641682460854 }, // K-Beauty Skincare Guide
        shipping: { id: "_aZ_" }, // Free shipping
        giftCard: { id: "-L8y", variantId: 44246914957494 } // $20 Gift Card
      }
    };
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateUpsellVisibility();
    this.showDebugInfo();
  }

  showDebugInfo() {
    // Make debug functions available globally for troubleshooting
    window.showCollagenDebug = () => {
      console.log('=== COLLAGEN BUNDLE DEBUG ===');
      this.updateUpsellVisibility();
      setTimeout(() => {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log('Current cart:', cart);
            console.log('Cart analysis:', this.analyzeCart(cart));
          });
      }, 100);
    };
    
    // Force initial upsell visibility update
    setTimeout(() => {
      this.updateUpsellVisibility();
    }, 1000);
  }

  bindEvents() {
    // Handle upgrade button clicks
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('bundle-upgrade-btn')) {
        e.preventDefault();
        this.handleUpgrade(e.target);
      }
    });

    // Listen for various cart update events
    document.addEventListener('cart:refresh', () => {
      this.updateUpsellVisibility();
    });
    
    document.addEventListener('cart:updated', () => {
      this.updateUpsellVisibility();
    });

    // Listen for cart drawer opening/closing
    document.addEventListener('DOMContentLoaded', () => {
      this.updateUpsellVisibility();
    });

    // More aggressive cart change detection
    this.observeCartChanges();
    this.startCartPolling();
  }

  observeCartChanges() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // Watch for cart drawer becoming active
    const drawerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('active')) {
            // Drawer opened, update upsell immediately
            setTimeout(() => {
              this.updateUpsellVisibility();
            }, 100);
          }
        }
      });
    });

    drawerObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Watch for cart content changes
    const contentObserver = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      
      mutations.forEach((mutation) => {
        // Check if cart items were added/removed/changed
        if (mutation.type === 'childList') {
          // Check if cart items container changed
          if (mutation.target.classList.contains('cart-items') || 
              mutation.target.id === 'CartDrawer-CartItems' ||
              mutation.target.tagName === 'CART-DRAWER-ITEMS') {
            shouldUpdate = true;
          }
        }
      });

      if (shouldUpdate) {
        // Debounce updates to avoid excessive calls
        clearTimeout(this.updateTimeout);
        this.updateTimeout = setTimeout(() => {
          this.updateUpsellVisibility();
        }, 100);
      }
    });

    contentObserver.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  startCartPolling() {
    // Poll cart changes every 1 second when drawer is open (more responsive)
    setInterval(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.classList.contains('active')) {
        this.updateUpsellVisibility();
      }
    }, 1000);
    
    // Also listen for global Shopify cart events
    document.addEventListener('cart:build', () => {
      this.updateUpsellVisibility();
    });
    
    document.addEventListener('cart:requestComplete', () => {
      this.updateUpsellVisibility();
    });
  }

  updateUpsellVisibility() {
    const upsellSection = document.getElementById('collagen-bundle-upsell');
    if (!upsellSection) {
      console.error('❌ Upsell section not found');
      return;
    }

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartAnalysis = this.analyzeCart(cart);
        this.showAppropriateUpsell(cartAnalysis, upsellSection);
      })
      .catch(error => {
        console.error('❌ Error fetching cart:', error);
        upsellSection.style.display = 'none';
      });
  }

  analyzeCart(cart) {
    let hasMainProduct = false;
    let hasBundleLevel2 = false;
    let hasBundleLevel3 = false;
    let mainProductQuantity = 0;
    let hasBundleProperties = false;

    cart.items.forEach(item => {
      if (item.product_id === this.mainProductId) {
        hasMainProduct = true;
        mainProductQuantity += item.quantity;

        // Check if item has bundle properties (indicates it's part of a bundle)
        if (item.properties && item.properties.__kaching_bundles) {
          hasBundleProperties = true;
          try {
            const bundleData = JSON.parse(item.properties.__kaching_bundles);
            // Determine bundle level based on bar ID rather than quantity
            if (bundleData.bar === this.bundleConfig.bars['3-get-3']) {
              hasBundleLevel3 = true;
            } else if (bundleData.bar === this.bundleConfig.bars['2-get-1']) {
              hasBundleLevel2 = true;
            } else {
              // Don't consider this as a "real" bundle for our logic
              hasBundleProperties = false;
            }
          } catch (e) {
            console.warn('Failed to parse bundle data:', e);
            // If we can't parse it, don't consider it a bundle
            hasBundleProperties = false;
          }
        }
      }
    });


    return {
      hasMainProduct,
      hasBundleLevel2,
      hasBundleLevel3,
      mainProductQuantity,
      hasBundleProperties
    };
  }

  showAppropriateUpsell(analysis, upsellSection) {
    const bundle2Get1 = upsellSection.querySelector('#bundle-2-get-1');
    const bundle3Get3 = upsellSection.querySelector('#bundle-3-get-3');

    // Hide all bundle options first
    if (bundle2Get1) bundle2Get1.style.display = 'none';
    if (bundle3Get3) bundle3Get3.style.display = 'none';

    if (!analysis.hasMainProduct) {
      // No main product in cart, hide entire upsell
      upsellSection.style.display = 'none';
      return;
    }

    // If already has bundle Level 3 (highest tier), hide upsell
    if (analysis.hasBundleLevel3) {
      upsellSection.style.display = 'none';
      return;
    }

    // Show upsell section
    upsellSection.style.display = 'block';

    if (analysis.hasBundleLevel2) {
      // Has 2+1 bundle, show upgrade to 3+3
      if (bundle3Get3) {
        bundle3Get3.style.display = 'block';
        this.updateUpgradeButton(bundle3Get3, 0, 6);
      }
    } else {
      // Has single products only (or non-bundle properties), show 2+1 bundle upgrade
      if (bundle2Get1) {
        bundle2Get1.style.display = 'block';
        this.updateUpgradeButton(bundle2Get1, 0, 3);
      }
    }
  }

  updateUpgradeButton(bundleElement, currentQuantity, targetQuantity) {
    const button = bundleElement.querySelector('.bundle-upgrade-btn');
    if (!button) return;

    button.dataset.currentQuantity = currentQuantity;
    button.dataset.quantity = targetQuantity;

    // Since we're replacing the cart contents with the bundle, always show "Upgrade to Bundle"
    button.textContent = 'Upgrade to Bundle';
  }

  async handleUpgrade(button) {
    const variantId = button.dataset.variantId;
    const targetQuantity = parseInt(button.dataset.quantity);
    const currentQuantity = parseInt(button.dataset.currentQuantity);
    
    // Determine bundle type
    const bundleType = targetQuantity === 3 ? '2-get-1' : '3-get-3';
    const barId = this.bundleConfig.bars[bundleType];
    
    // Validate variant ID
    if (!variantId || variantId === '' || variantId === 'undefined') {
      console.error('Invalid variant ID:', variantId);
      this.showErrorMessage('Product variant not found. Please refresh the page and try again.');
      return;
    }

    // Calculate quantity to add
    const quantityToAdd = targetQuantity - currentQuantity;

    if (quantityToAdd <= 0) {
      console.warn('No additional quantity needed');
      return;
    }

    console.log('Upgrading to bundle:', {
      bundleType,
      barId,
      targetQuantity,
      currentQuantity,
      quantityToAdd
    });

    // Update button state
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      // Step 1: Clear existing cart items to start fresh
      await this.clearCart();
      
      // Step 2: Add bundle items (gifts + buy quantity) - First Kaching call
      const bundleInstanceId = await this.addBundleItemsFirstCall(bundleType, targetQuantity);
      
      // Step 3: Add free quantity to activate bundle - Second Kaching call
      await this.addFreeQuantitySecondCall(bundleType, bundleInstanceId);
      
      // Success feedback
      button.textContent = 'Bundle Added! ✓';
      
      // Refresh cart content without closing drawer
      await this.refreshCartDrawer();

    } catch (error) {
      console.error('Error upgrading bundle:', error);
      button.textContent = 'Try Again';
      this.showErrorMessage(error.message || 'Failed to upgrade bundle. Please try again.');
    } finally {
      // Reset button after delay
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 3000);
    }
  }

  async clearCart() {
    // Clear cart to start fresh with bundle
    const response = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to clear cart');
    }
  }

  async addBundleItemsFirstCall(bundleType, targetQuantity) {
    // Generate unique bundle ID (use same ID for all items in the bundle)
    const bundleInstanceId = this.generateRandomId();
    
    // Prepare items array (replicating Kaching's FIRST call structure)
    const items = [];
    
    // Determine buy quantity (what we pay for)
    let buyQuantity;
    if (bundleType === '2-get-1') {
      buyQuantity = 2; // Buy 2, get 1 free
    } else if (bundleType === '3-get-3') {
      buyQuantity = 3; // Buy 3, get 3 free
    } else {
      buyQuantity = targetQuantity; // Fallback
    }
    
    // Add gifts FIRST (matching Kaching's order)
    if (bundleType === '2-get-1' || bundleType === '3-get-3') {
      // Add K-Beauty Skincare Guide
      items.push({
        id: this.bundleConfig.gifts.skincare.variantId,
        quantity: 1,
        properties: {
          "__kaching_bundles": JSON.stringify({
            id: bundleInstanceId,
            deal: this.bundleConfig.dealId,
            gift: this.bundleConfig.gifts.skincare.id
          })
        }
      });
    }

    if (bundleType === '3-get-3') {
      // Add $20 Gift Card for highest tier
      items.push({
        id: this.bundleConfig.gifts.giftCard.variantId,
        quantity: 1,
        properties: {
          "__kaching_bundles": JSON.stringify({
            id: bundleInstanceId,
            deal: this.bundleConfig.dealId,
            gift: this.bundleConfig.gifts.giftCard.id
          })
        }
      });
    }
    
    // Add main product with bundle properties (buy quantity only)
    items.push({
      id: this.mainVariantId,
      quantity: buyQuantity,
      selling_plan: this.sellingPlan,
      properties: {
        "__kaching_bundles": JSON.stringify({
          deal: this.bundleConfig.dealId,
          main: true,
          id: bundleInstanceId,
          bar: this.bundleConfig.bars[bundleType]
        })
      }
    });

    // Debug: console.log('FIRST CALL payload:', { items, bundleInstanceId });

    // First call - Add gifts and buy quantity
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js?kaching_bundles=true&partial=true', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to add bundle items (first call): ${errorText}`);
    }

    return bundleInstanceId;
  }

  async addFreeQuantitySecondCall(bundleType, bundleInstanceId) {
    // Determine free quantity (what we get free)
    let freeQuantity;
    if (bundleType === '2-get-1') {
      freeQuantity = 1; // Get 1 free
    } else if (bundleType === '3-get-3') {
      freeQuantity = 3; // Get 3 free
    } else {
      freeQuantity = 1; // Fallback
    }
    
    // Debug: Adding free quantity to activate bundle
    
    // Generate random deal field name (matching Kaching's pattern)
    const dealFieldName = `kaching-bundles-deal-${this.generateRandomId()}`;
    
    // Create form data (replicating Kaching's SECOND call exactly)
    const formData = new FormData();
    formData.append('selling_plan', this.sellingPlan);
    formData.append('properties[__kaching_bundles]', JSON.stringify({
      id: bundleInstanceId,
      deal: this.bundleConfig.dealId,
      bar: this.bundleConfig.bars[bundleType],
      main: true,
      bxgy: true
    }));
    formData.append('form_type', 'product');
    formData.append('utf8', '✓');
    formData.append('id', this.mainVariantId);
    formData.append('quantity', freeQuantity);
    formData.append(dealFieldName, this.bundleConfig.bars[bundleType]);
    formData.append('product-id', this.mainProductId);
    formData.append('section-id', 'cart-drawer');
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('section_url', '/products/bio-collagen-mask');

    // Debug: console.log('SECOND CALL payload:', { selling_plan: this.sellingPlan, quantity: freeQuantity, bundleInstanceId, bar: this.bundleConfig.bars[bundleType] });

    // Second call - Add free quantity to activate bundle
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to add free items (second call): ${errorText}`);
    }
  }

  async refreshCartDrawer() {
    try {
      // Use the native Shopify cart refresh mechanism
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer) {
        // Fetch sections to update cart drawer content
        const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
        const sectionsUrl = `${window.location.pathname}?sections=${sectionsToRender.join(',')}`;
        
        const response = await fetch(sectionsUrl);
        const sections = await response.json();
        
        // Update cart drawer content
        if (sections['cart-drawer']) {
          const parser = new DOMParser();
          const newCartDrawer = parser.parseFromString(sections['cart-drawer'], 'text/html');
          const newContent = newCartDrawer.querySelector('cart-drawer');
          
          if (newContent) {
            // Replace the inner content while keeping the drawer open
            const currentInner = cartDrawer.querySelector('.drawer__inner');
            const newInner = newContent.querySelector('.drawer__inner');
            
            if (currentInner && newInner) {
              currentInner.innerHTML = newInner.innerHTML;
            }
          }
        }
        
        // Update cart icon bubble
        if (sections['cart-icon-bubble']) {
          const cartBubble = document.querySelector('.cart-count-bubble');
          if (cartBubble) {
            const parser = new DOMParser();
            const newBubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
            const newBubbleContent = newBubble.querySelector('.cart-count-bubble');
            if (newBubbleContent) {
              cartBubble.replaceWith(newBubbleContent);
            }
          }
        }
      }
      
      // Trigger cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      
      // Update our upsell visibility after cart change
      setTimeout(() => {
        this.updateUpsellVisibility();
      }, 500);
      
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      
      // Fallback: try to close and reopen the drawer to force refresh
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.close === 'function') {
          cartDrawer.close();
        }
        setTimeout(() => {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }, 100);
      }
    }
  }

  generateRandomId() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  showErrorMessage(message) {
    // Try to show error in cart drawer error area
    const errorContainer = document.getElementById('CartDrawer-CartErrors');
    if (errorContainer) {
      errorContainer.innerHTML = `<div class="cart__error">${message}</div>`;
      setTimeout(() => {
        errorContainer.innerHTML = '';
      }, 5000);
    }
  }
}

// Initialize when DOM is ready
let collagenUpsellInstance = null;

document.addEventListener('DOMContentLoaded', () => {
  collagenUpsellInstance = new CollagenBundleUpsell();
  
  // Make it globally available for debugging
  window.testCollagenUpsell = () => {
    console.log('🧪 Manual upsell test triggered');
    if (collagenUpsellInstance) {
      collagenUpsellInstance.updateUpsellVisibility();
    } else {
      console.error('Upsell instance not found');
    }
  };
  
  window.forceShowUpsell = () => {
    console.log('🔧 Forcing upsell to show');
    const upsellSection = document.getElementById('collagen-bundle-upsell');
    if (upsellSection) {
      upsellSection.style.display = 'block';
      const bundle2Get1 = upsellSection.querySelector('#bundle-2-get-1');
      if (bundle2Get1) {
        bundle2Get1.style.display = 'block';
      }
    }
  };
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    collagenUpsellInstance = new CollagenBundleUpsell();
  });
} else {
  collagenUpsellInstance = new CollagenBundleUpsell();
  
  // Make it globally available for debugging
  window.testCollagenUpsell = () => {
    console.log('🧪 Manual upsell test triggered');
    if (collagenUpsellInstance) {
      collagenUpsellInstance.updateUpsellVisibility();
    } else {
      console.error('Upsell instance not found');
    }
  };
  
  window.forceShowUpsell = () => {
    console.log('🔧 Forcing upsell to show');
    const upsellSection = document.getElementById('collagen-bundle-upsell');
    if (upsellSection) {
      upsellSection.style.display = 'block';
      const bundle2Get1 = upsellSection.querySelector('#bundle-2-get-1');
      if (bundle2Get1) {
        bundle2Get1.style.display = 'block';
      }
    }
  };
}
